export const establishments = [
  { id: 'all', label: 'All' },
  { id: 'beverageking', label: 'Beverage King' },
  { id: 'tropicaldrinks', label: 'Tropical Drinks' },
  { id: 'georgetownliquor', label: 'Georgetown Liquor' },
  { id: 'caribcooler', label: 'Carib Cooler' },
];

export const reviews: {
  id: string;
  user: string;
  avatar: string;
  establishment: string;
  establishmentId: string;
  rating: number;
  comment: string;
  date: string;
  verified: boolean;
  helpful: number;
}[] = [];

export const stats = [
  { label: 'Happy Customers', value: '15,000+' },
  { label: 'Partner Stores', value: '80+' },
  { label: 'Avg. Delivery Time', value: '28 min' },
  { label: 'Average Rating', value: '4.8 ★' },
];
